var map = {
	"./alexia.png": 4040,
	"./bit-draw.png": 9607,
	"./bubbli.png": 1029,
	"./car-tuning.png": 7373,
	"./cinema.png": 864,
	"./cooking.png": 5736,
	"./geometa.png": 6847,
	"./hank.png": 4353,
	"./hydro.png": 5305,
	"./lugar.png": 1649,
	"./matematicando.png": 4753,
	"./mine.png": 9344,
	"./pirate.png": 7768,
	"./pong.png": 966,
	"./renegado.png": 3246,
	"./resident.png": 7039,
	"./space.png": 1910,
	"./stardew.png": 8922,
	"./supapo.png": 9894,
	"./trix.png": 6845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7222;